module.exports = __webpack_public_path__ + "static/calendar_data_sources_add-51fe12e7d441236b14f9ac606ed4dbec.png";